const PlayCircleSVG = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
      <path
        d='M5.83333 0C2.61158 0 0 2.61158 0 5.83333C0 9.05508 2.61158 11.6667 5.83333 11.6667C9.05508 11.6667 11.6667 9.05508 11.6667 5.83333C11.6667 2.61158 9.05508 0 5.83333 0ZM7.85164 6.45227L5.23953 8.0506C4.71978 8.36852 4.05122 7.99579 4.05122 7.38737V4.2793C4.05122 3.67088 4.71978 3.29815 5.23953 3.61607L7.85164 5.2144C8.31481 5.4979 8.31481 6.16877 7.85164 6.45227Z'
        fill='#0066FF'
      />
    </svg>
  );
};

export default PlayCircleSVG;
